export enum AllocationsViewModel {
    Insights = 'insights',
    Workbench = 'workbench',
    Settings = 'settings',
    Summaries = 'summaries'
}
